import React, { Component } from 'react';
import SearchBoxPlaceholder from 'app/common/react/components/growth/unauth/open/search/SearchBox/SearchBoxPlaceholder';

const searchBoxLoader = () =>
  import(/* webpackChunkName: "SearchBoxCommon" */ 'app/common/react/components/growth/unauth/open/search/SearchBox/SearchBox');

export class SearchBoxWrapper extends Component {
  state = {
    LoadedComponent: null,
    placeholderBoxFocused: false,
    placeholderBoxText: '', // Pass placeholderBox text, if any, into the SearchBox once loaded
  };

  componentDidMount() {
    this.mounted = true;

    this.loadComponent();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  mounted = false;

  loadComponent() {
    searchBoxLoader().then((module) => {
      if (!this.mounted) {
        return;
      }

      this.setState({
        LoadedComponent: module.default,
      });
    });
  }

  updatePlaceholderBoxFocus = (focused) => {
    this.setState({
      placeholderBoxFocused: focused,
    });
  };

  updatePlaceholderBoxText = (text) => {
    this.setState({
      placeholderBoxText: text,
    });
  };

  render() {
    const { LoadedComponent, placeholderBoxFocused, placeholderBoxText } = this.state;

    return LoadedComponent ? (
      <LoadedComponent
        initialFocus={placeholderBoxFocused}
        initialText={placeholderBoxText}
        {...this.props}
      />
    ) : (
      <SearchBoxPlaceholder
        text={placeholderBoxText}
        focused={placeholderBoxFocused}
        updateFocus={this.updatePlaceholderBoxFocus}
        updateText={this.updatePlaceholderBoxText}
      />
    );
  }
}

export default SearchBoxWrapper;
